import { useContext } from 'react';

import { RfqOfferCardContext } from '../../../components/RfqOfferCard/components/RfqOfferCardContext';

export const useRfqOfferCardContext = () => {
    const context = useContext(RfqOfferCardContext);

    if (!context) {
        throw new Error('useRfqOfferCardContext must be used within RfqOfferCardContextProvider');
    }

    return context;
};
